<template>
  <CustomUpdateDialog
    dialogTitle="بروزرسانی لینک جلسه"
    dialogId="change-user-link-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateScheduleLinkRequest"
  >
    <BCol>
      <TextInput
        dir="auto"
        inputId="user-link-input"
        inputLabel="لینک جلسه فعلی شما"
        inputPlaceholder="http://meet.google.com..."
        v-model="updateUserLinkPayload.links"
      ></TextInput>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      isOkButtonDisabled: false,
      updateUserLinkPayload: {
        userId: null,
        links: null,
      },
    };
  },
  methods: {
    async sendUpdateScheduleLinkRequest() {
      try {
        this.updateUserLinkPayload.userId = getUserData().user.userId;
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateUserLinks = new UpdateUserLinks(_this);
        updateUserLinks.setRequestParamDataObj(_this.updateUserLinkPayload);
        await updateUserLinks.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "لینک جلسه با موفقیت ویرایش شد.",
              },
            });
            _this.updateUserLinkPayload = {
              userId: null,
              links: null,
            };
            this.$bvModal.hide("change-user-link-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    TextInput,
    BCol,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import { getUserData } from "@/auth/utils";
import { BCol } from "bootstrap-vue";
import { UpdateUserLinks } from "@/libs/Api/Users";
</script>
